import { FC, ReactElement } from 'react'
import { Link } from 'react-router'

import { TrackRoutes } from '../../../../../pages/Tracks/TrackRoutes'
import { Track } from '../../../../entities/Track/Track'
import { formatDate } from '../../../../helpers/date'
import { PrivateRouteGroupRoutes } from '../../../../routes/routes'
import { DateFormat } from '../../../../types/dateFormatTypes'
import UserShiftTrackTime from '../UserShiftTrackTime/UserShiftTrackTime'

import './CalendarUserTrack.scss'

interface CalendarUserTrackProps {
    isOrphan?: boolean;
    track: Track;
    className?: string;
}

const CalendarUserTrack: FC<CalendarUserTrackProps> = ({ isOrphan, track, className = '' }): ReactElement => {
    const href = `${PrivateRouteGroupRoutes.tracks()}/${TrackRoutes.finished(track.id, formatDate(track.checkInOutPeriod.start, DateFormat.apiDate))}`

    return (
        <Link
            to={href}
            className={`calendar-user-track ${className}`}
        >
            <UserShiftTrackTime
                isOrphan={isOrphan}
                trackPeriod={track.billablePeriod}
                trackShift={track.shift}
                className="calendar-user-track__track-time"
            />
        </Link>
    )
}

export default CalendarUserTrack
